import React, { Component } from 'react';
import { BASE_URL } from '../../constant';
import { IMG_URL, ADMIN_URL } from "../../constant";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import ad1 from '../../../src/assets/images/ad-banner/curatedadbanner_v1.png';
const banner_arr = [
    {
        image: '/assets/images/ad-banner/768-90-180822-img-1.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/768-90-180822-img-2.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/768-90-180822-img-3.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/768-90-180822-img-4.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/768-90-180822-img-5.png',
        link: `https://www.bewise.in`
    },
    {
        image: '/assets/images/ad-banner/768-90-180822-img-6.png',
        link: `https://www.bewise.in`
    },
]
class AdHorizontal extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }
    render() {
        const settingsT = {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000,
            dots: false,
            arrows: false
        };
        return (
            <React.Fragment>
                <div className="">
                    <Slider {...settingsT}>
                        {banner_arr.map((item, i) => {
                            return (

                                <a href={item.link}>
                                    <div className="text-center adstwo">
                                        <div className="ads-sction2 insighttopad" >
                                            <img src={item.image} alt='banner' />
                                        </div>
                                    </div>
                                </a>
                            )
                        })}
                    </Slider>
                </div>
                {/* Ads Section end */}
            </React.Fragment >
        );
    }
}


export {AdHorizontal};